import { db } from '../../config/firebase/config';
import { collection, addDoc, Timestamp } from 'firebase/firestore';

// 🔒 All allowed log types
export type LogType =
  | 'staff_add'
  | 'staff_role_change'
  | 'staff_remove'
  | 'menu_edit'
  | 'settings_update'
  | 'logo_update'
  | 'restaurant_activate_toggle'
  | 'mesa_close'
  | 'payment_confirmed'
  | 'menu_item_add'
  | 'menu_item_update'
  | 'menu_item_delete'
  | 'error';

export interface LogEntry {
  type: LogType;
  userId?: string; // Optional: Who performed the action
  userEmail?: string;
  restaurantId: string;
  origin?: 'admin' | 'cloud-function' | 'app' | 'system';
  details: Record<string, any>;
  timestamp: Timestamp; // Always generated inside the function
}

// Omitting timestamp because we auto-generate it
export type LogInput = Omit<LogEntry, 'timestamp'>;

export const logAction = async (log: LogInput): Promise<void> => {
  try {
    const logDataToSave: LogEntry = {
      ...log,
      userId: log.userId || 'system',
      userEmail: log.userEmail || 'system',
      timestamp: Timestamp.now()
    };
    await addDoc(collection(db, 'logs'), logDataToSave);
  } catch (error) {
    console.error('[logAction] Error writing to logs:', error);
  }
};
